// use this Api as a function to make api calls;
import axiosInstance from '../axios';
import { API_ROUTES } from '../../enums/API_ROUTES';
import { RENOTIFY_BODY, TNOTIFICATION } from '../../enums/NOTIFICATION';
import { isDeletedComment } from '../../helpers/comments';

export const getAllNotifications = async (bustCache = false): Promise<{ data: TNOTIFICATION[] }> => {
  const response = await axiosInstance.get<TNOTIFICATION[]>(API_ROUTES.NOTIFICATION, bustCache ? { params: { _: Date.now() } } : undefined);
  return {
    ...response,
    data: response.data
      .filter((notification) => !isDeletedComment(notification.comment))
      .map((notification) => ({
        ...notification,
        child_notifications: (notification.child_notifications || []).filter((child) => !isDeletedComment(child.comment)),
      })),
  };
};

export const deleteNotifications = async (id?: string, all?: boolean) => {
  const res = await axiosInstance.delete(`${API_ROUTES.NOTIFICATION}/${id}${all ? '?all=true' : ''}`);
  return res;
};

export const patchNotifications = async (id?: string, all?: boolean) => {
  const res = await axiosInstance.patch(`${API_ROUTES.NOTIFICATION}`, {
    all,
    id,
  });
  return res;
};

export const postRenotify = async (data: RENOTIFY_BODY, contentUrl: string, messageTextForSharedContent?: string) => {
  const url = contentUrl.replace(/\s/g, '%20');

  const res = await axiosInstance.post(API_ROUTES.NOTIFICATION_RENOTIFY, {
    ...data,
    contentUrl: url,
    messageTextForSharedContent,
  });
  return res;
};
